/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigPhoneNumberExtension
 */
export interface BidirectionalActionConfigPhoneNumberExtension {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    required: boolean;
    /**
     * 
     */
    max_length?: number;
}

/**
 * Check if a given object implements the BidirectionalActionConfigPhoneNumberExtension interface.
 */
export function instanceOfBidirectionalActionConfigPhoneNumberExtension(value: object): value is BidirectionalActionConfigPhoneNumberExtension {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function BidirectionalActionConfigPhoneNumberExtensionFromJSON(json: any): BidirectionalActionConfigPhoneNumberExtension {
    return BidirectionalActionConfigPhoneNumberExtensionFromJSONTyped(json, false);
}

export function BidirectionalActionConfigPhoneNumberExtensionFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigPhoneNumberExtension {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'required': json['required'],
        'max_length': json['max_length'] == null ? undefined : json['max_length'],
    };
}

export function BidirectionalActionConfigPhoneNumberExtensionToJSON(json: any): BidirectionalActionConfigPhoneNumberExtension {
    return BidirectionalActionConfigPhoneNumberExtensionToJSONTyped(json, false);
}

export function BidirectionalActionConfigPhoneNumberExtensionToJSONTyped(value?: BidirectionalActionConfigPhoneNumberExtension | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'required': value['required'],
        'max_length': value['max_length'],
    };
}

